import React from 'react';
import { useSelector } from 'react-redux';
import { usePersonalInformationEditState } from 'hooks/usePersonalInformationEditState';
import { isEmpty, partial } from 'lodash';

import {
  getCurrentUserId,
  getPayrollHandleUserMergeRequestPhase2Enabled,
} from 'selectors/session';

import Box from 'components/Box';
import TextField from 'components/forms/TextField';
import Text from 'components/Text';

import { toI18n } from 'util/i18n';

const ContactInfo = ({
  handleChange,
  handleBlur,
  firstName,
  lastName,
  phone,
  email,
  requestInformation,
  errors = {},
  user,
}) => {
  const currentUserId = useSelector(getCurrentUserId);
  const payrollHandleUserMergeRequestPhase2Enabled = useSelector(
    getPayrollHandleUserMergeRequestPhase2Enabled
  );

  const {
    drawerContactInformationEditButtonDisabled,
    showDrawerContactInformationAlert,
  } = usePersonalInformationEditState({
    isRolloutEnabled: payrollHandleUserMergeRequestPhase2Enabled,
    user,
    currentUserId,
  });

  return (
    <>
      {showDrawerContactInformationAlert && (
        <Box p={12} bg="blueLightest" bradius={8} mb24>
          <Text
            i18n="product_usage.hover_text.edit_button_disabled_text"
            i18nProps={{
              employee_name: firstName,
            }}
          />
        </Box>
      )}
      <Box row mb24>
        <Box mr12 w={235}>
          <Box mb8>
            <Text fs14 fw600 i18n="add_team.first_name" />*
          </Box>
          <Box>
            <TextField
              name="firstName"
              theme="bordered"
              value={firstName}
              errorText={errors.firstName}
              onChange={partial(handleChange, 'firstName')}
              onBlur={partial(handleBlur, 'firstName')}
              disabled={drawerContactInformationEditButtonDisabled}
            />
          </Box>
        </Box>

        <Box w={235}>
          <Box mb={8}>
            <Text fs14 fw600 i18n="add_team.last_name" />
          </Box>
          <Box>
            <TextField
              name="lastName"
              theme="bordered"
              value={lastName}
              errorText={errors.lastName}
              onBlur={partial(handleBlur, 'lastName')}
              onChange={partial(handleChange, 'lastName')}
              disabled={drawerContactInformationEditButtonDisabled}
            />
          </Box>
        </Box>
      </Box>

      <Box mb={24}>
        <Box mb={8}>
          <Text fs14 fw600 i18n="add_team.individual_drawer.contact_info" />
        </Box>
        <Box row>
          <Box mr={12} w={235}>
            <TextField
              errorBorder={
                requestInformation === 'packet' &&
                isEmpty(phone) &&
                isEmpty(email)
              }
              name="phone"
              type="phone"
              placeholder={toI18n(
                'add_team.individual_drawer.phone_placeholder'
              )}
              errorText={errors.phone}
              theme="bordered"
              value={phone}
              onChange={partial(handleChange, 'phone')}
              onBlur={partial(handleBlur, 'phone')}
              disabled={drawerContactInformationEditButtonDisabled}
            />
          </Box>
          <Box w={235}>
            <TextField
              errorBorder={
                requestInformation === 'packet' &&
                isEmpty(phone) &&
                isEmpty(email)
              }
              name="email"
              placeholder={toI18n(
                'add_team.individual_drawer.email_placeholder'
              )}
              errorText={errors.email}
              theme="bordered"
              value={email}
              onChange={partial(handleChange, 'email')}
              onBlur={partial(handleBlur, 'email')}
              disabled={drawerContactInformationEditButtonDisabled}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ContactInfo;
